import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg leading-7 font-medium text-black" }, "Property value", -1)
const _hoisted_3 = { class: "flex flex-col gap-y-3" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "setTo",
  class: "text-sm font-medium text-gray-700 ml-2 cursor-pointer"
}, "Set to", -1)
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "copy",
  class: "text-sm font-medium text-gray-700 ml-2 cursor-pointer"
}, "Copy to", -1)

import { computed, onMounted, watch } from "vue"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsDropdown from "@/components/GgmsDropdown.vue"
import GgmsPhoneTelInput from "@/components/GgmsPhoneTelInput.vue"
import { useWorkflowStore } from "@/stores/workflow"
import { useGridCollectionStore } from "@/stores/grid-collection"
import { AttributeType } from "@/shared/models/attributes"


export default /*#__PURE__*/_defineComponent({
  __name: 'PropertyValueComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()
const gridCollectionStore = useGridCollectionStore()

const modelValue = computed(() => workflowStore.modelValue)
const inputFieldType = computed(() => (modelValue.value.attribute ? modelValue.value.attribute?.type : "string"))
const prototypes = computed(() => {
    gridCollectionStore.getPrototypesByPage("leads")
    return gridCollectionStore.prototypes
})
const clearStyle = computed(() => [
    modelValue.value.attribute?.isRequired ? "text-gray-300" : "text-gray-700",
    "text-sm font-medium ml-2 cursor-pointer",
])
const objectTypes = [AttributeType.String, AttributeType.Number, AttributeType.Date]
const options = computed(() =>
    prototypes.value[0].attributes.filter((att) => objectTypes.includes(att.type.toLowerCase()))
)

const copyOptions = computed(() => {
    return prototypes.value[0].attributes.filter(
        (att) => att.type === modelValue.value.attribute?.type && att._id !== modelValue.value.attribute._id
    )
})

function getAttributeByName(name: string) {
    return prototypes.value[0].attributes.find((attribute) => attribute.name === name)
}

function getComponentByType() {
    if (!modelValue.value.attribute) {
        return GgmsInput
    }
    switch (modelValue.value.attribute?.type?.toLowerCase()) {
        case AttributeType.Phones:
            return GgmsPhoneTelInput
        default:
            return GgmsInput
    }
}

function setNodeNotChanged() {
    workflowStore.changedNode = false
}

onMounted(() => {
    gridCollectionStore.getPrototypesByPage("leads")
})

watch(
    () => modelValue.value.event,
    () => {
        if (!workflowStore.changedNode) {
            modelValue.value.value = ""
        }
    }
)

watch(
    () => modelValue.value.property,
    () => {
        modelValue.value.attribute = getAttributeByName(modelValue.value.property)
        if (!workflowStore.changedNode) {
            modelValue.value.value = ""
            modelValue.value.event = ""
        }
    }
)

watch(
    () => [modelValue.value.property, modelValue.value.event, modelValue.value.value],
    () => {
        if (modelValue.value.event === "setTo" || modelValue.value.event === "copy") {
            workflowStore.areButtonDisabled = !(
                modelValue.value.property &&
                modelValue.value.event &&
                modelValue.value.value
            )
            if (modelValue.value.event === "copy") {
                modelValue.value.copyToAttribute = getAttributeByName(modelValue.value.value)
            }
        } else {
            workflowStore.areButtonDisabled = !(modelValue.value.property && modelValue.value.event)
        }
    }
)

return (_ctx: any,_cache: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(GgmsDropdown, {
      modelValue: modelValue.value.property,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.property) = $event)),
      options: options.value,
      optionLabel: "displayName",
      optionValue: "name",
      class: "w-full text-ellipsis mb-1",
      panelClass: "w-20 text-ellipsis",
      placeholder: "Select property",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (setNodeNotChanged()))
    }, null, 8, ["modelValue", "options"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_RadioButton, {
          modelValue: modelValue.value.event,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue.value.event) = $event)),
          value: "setTo",
          name: "setTo",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (setNodeNotChanged()))
        }, null, 8, ["modelValue"]),
        _hoisted_5
      ]),
      (modelValue.value.event === 'setTo')
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentByType()), {
            key: 0,
            modelValue: modelValue.value.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modelValue.value.value) = $event)),
            type: inputFieldType.value,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (setNodeNotChanged()))
          }, null, 8, ["modelValue", "type"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_RadioButton, {
          modelValue: modelValue.value.event,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((modelValue.value.event) = $event)),
          value: "clear",
          name: "clear",
          disabled: modelValue.value.attribute?.isRequired,
          onClick: _cache[7] || (_cache[7] = ($event: any) => (setNodeNotChanged()))
        }, null, 8, ["modelValue", "disabled"]),
        _createElementVNode("label", {
          for: "clear",
          class: _normalizeClass(clearStyle.value)
        }, "Clear", 2)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_RadioButton, {
          modelValue: modelValue.value.event,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((modelValue.value.event) = $event)),
          value: "copy",
          name: "copy",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (setNodeNotChanged()))
        }, null, 8, ["modelValue"]),
        _hoisted_8
      ]),
      (modelValue.value.event === 'copy')
        ? (_openBlock(), _createBlock(GgmsDropdown, {
            key: 1,
            modelValue: modelValue.value.value,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((modelValue.value.value) = $event)),
            options: copyOptions.value,
            optionLabel: "displayName",
            optionValue: "name",
            class: "w-full text-ellipsis",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (setNodeNotChanged()))
          }, null, 8, ["modelValue", "options"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})